import { Provider } from '@angular/core';
import { LegacySidebarService } from 'guideline/feature-sidebar';
import { ExpandService } from 'libs/shared/util-common/src/lib/expand.service';

import { CommentService } from '@treetop/shared/comments';
import { ReferenceNumberingService } from '@treetop/shared/reference-numbering';

import { LinksService } from '../links.service';
import { ScrollService } from '../scroll.service';
import { ConcurrencyService } from './concurrency.service';
import { GuidelineGraphService } from './guideline-graph.service';
import { GuidelineService } from './guideline.service';
import { SelectionService } from './selection.service';

export function providePublicGuideline(): Provider[] {
  return [
    GuidelineService,
    ReferenceNumberingService,
    ExpandService,
    SelectionService,
    LegacySidebarService,
    ExpandService,
    GuidelineGraphService,
    ScrollService,
    LinksService,
  ];
}

export function provideGuideline(): Provider[] {
  return [
    GuidelineService,
    ReferenceNumberingService,
    ExpandService,
    SelectionService,
    LegacySidebarService,
    ExpandService,
    GuidelineGraphService,
    ScrollService,
    LinksService,
    CommentService,
    ConcurrencyService,
  ];
}
